export function select(el) {
    return typeof el === 'string' ? document.querySelector(el) : el;
}
export function addClass(el, className) {
    var domEl = select(el);
    domEl === null || domEl === void 0 ? void 0 : domEl.classList.add(className);
    return domEl;
}
export function removeClass(el, className) {
    var domEl = select(el);
    domEl === null || domEl === void 0 ? void 0 : domEl.classList.remove(className);
    return domEl;
}
export function toggleClass(el, className, onAdd, onRemove) {
    var domEl = select(el);
    if (domEl === null || domEl === void 0 ? void 0 : domEl.classList.contains(className)) {
        domEl.classList.remove(className);
        onRemove === null || onRemove === void 0 ? void 0 : onRemove();
    }
    else {
        domEl === null || domEl === void 0 ? void 0 : domEl.classList.add(className);
        onAdd === null || onAdd === void 0 ? void 0 : onAdd();
    }
    return domEl;
}
